import { atomWithReset } from 'jotai/utils';

import { CancelPane } from './types';

export const cancelPane = atomWithReset<CancelPane>({
  isOpen: false,
});
